/* =====================================================================
   BZF FILTERS 2027 — controller unico per i filtri collezione.
   Desktop: barra di pill con dropdown. Mobile: drawer full-screen.
   Filtraggio instant (AJAX + section render), conteggio risultati live,
   swatch colore, pill taglia, fasce prezzo rapide, sort, clear.
   Fonte dati: collection.filters (Shopify). Niente dipendenze esterne.
   ===================================================================== */
(function () {
  'use strict';

  const DESKTOP = () => window.matchMedia('(min-width: 750px)').matches;
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  class BzfFilters2027 {
    constructor(root) {
      this.toolbar = root;
      this.form = qs('[data-filters-form]', root);
      this.drawer = qs('[data-bzf-drawer]', root);
      this.overlay = qs('[data-bzf-overlay]'); // sibling of toolbar
      this.grid = qs('[data-products-grid]');
      this.activeWrap = qs('[data-active-filters]');
      this.sortSelect = qs('[data-bzf-sort]', root);
      this.cache = new Map();
      this.debounce = null;
      if (!this.form || !this.grid) return;
      this.init();
    }

    init() {
      this.bindFacetToggles();
      this.bindDrawer();
      this.bindForm();
      this.bindPriceChips();
      this.bindSort();
      this.bindClear();
      this.bindApply();
      this.bindActiveRemoval();
      this.bindLoadMore();
      this.bindOutside();
      this.syncActiveStates();
      this.updateActiveCount();
      // Il drawer va spostato su <body> SOLO su mobile: cosi' esce dallo stacking context
      // della toolbar sticky e copre header/mobile-bar a schermo intero.
      // Su desktop invece deve restare DENTRO la toolbar (host in display:contents ->
      // le pill dei filtri si dispongono inline nella barra). Se lo spostiamo sempre,
      // su desktop le pill finiscono in fondo al <body> e spariscono dalla barra.
      // Segnaposto per riportarlo esattamente al suo posto quando si torna desktop.
      if (this.drawer) {
        this._drawerHome = document.createComment('bzf-drawer-home');
        this.drawer.parentNode.insertBefore(this._drawerHome, this.drawer);
      }
      this._mqMobile = window.matchMedia('(max-width: 749px)');
      this.placeDrawer();
      const onMq = () => this.placeDrawer();
      if (this._mqMobile.addEventListener) this._mqMobile.addEventListener('change', onMq);
      else if (this._mqMobile.addListener) this._mqMobile.addListener(onMq);
    }

    // Colloca drawer + overlay in base al viewport. I listener restano attaccati ai nodi
    // anche dopo lo spostamento, quindi si puo' rimbalzare tra body e toolbar liberamente.
    placeDrawer() {
      try {
        const mobile = this._mqMobile && this._mqMobile.matches;
        if (mobile) {
          if (this.drawer && this.drawer.parentElement !== document.body) document.body.appendChild(this.drawer);
          if (this.overlay && this.overlay.parentElement !== document.body) document.body.appendChild(this.overlay);
        } else {
          // torna desktop: rimetti il drawer nella toolbar e chiudilo
          if (this.drawer && this._drawerHome && this.drawer.previousSibling !== this._drawerHome) {
            this._drawerHome.parentNode.insertBefore(this.drawer, this._drawerHome.nextSibling);
          }
          this.closeDrawer();
        }
      } catch (e) {}
    }

    /* ---- load more (paginazione "Carica altri") ---- */
    bindLoadMore() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-load-more]');
        if (btn) { e.preventDefault(); this.loadMore(btn); }
      });
    }
    async loadMore(btn) {
      const url = btn.dataset.url;
      if (!url || btn.classList.contains('loading')) return;

      // Safety cap: dopo N accodamenti via AJAX si passa a una navigazione pulita
      // (DOM azzerato) invece di accumulare centinaia di card. Su iPhone il DOM
      // che cresce all'infinito col load-more satura il webview e va in errore.
      // Configurabile via data-max-appends (settings.beezfy_loadmore_max_pages).
      // Il valore viene catturato UNA VOLTA e tenuto sull'istanza: cosi' regge
      // anche se una pagina paginata (cache CDN vecchia) non ha l'attributo.
      if (this._maxAppends == null) {
        this._maxAppends = parseInt(btn.dataset.maxAppends, 10) || 0;
      }
      if (this._maxAppends > 0) {
        if ((this._appendCount || 0) >= this._maxAppends) {
          window.location.assign(url); // carica la pagina successiva fresca
          return;
        }
        this._appendCount = (this._appendCount || 0) + 1;
      }

      btn.classList.add('loading');
      try {
        const html = await (await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-products-grid]');
        if (newGrid) {
          const frag = document.createDocumentFragment();
          Array.from(newGrid.children).forEach((n) => frag.appendChild(n.cloneNode(true)));
          this.grid.appendChild(frag);
        }
        this.syncPagination(doc);
        this.reinit();
      } catch (err) {
        console.error('[bzf-filters] load-more:', err);
        btn.classList.remove('loading');
      }
    }
    syncPagination(doc) {
      const wrap = this.grid.closest('.bzfy-grid') || this.grid.parentElement;
      if (!wrap) return;
      const cur = wrap.querySelector('[data-pagination]');
      const next = doc.querySelector('[data-pagination]');
      if (cur) cur.remove();
      if (next) wrap.appendChild(next.cloneNode(true));
    }

    /* ---- apertura pannelli (dropdown desktop / accordion mobile) ---- */
    bindFacetToggles() {
      qsa('[data-facet-toggle]', this.form).forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const facet = btn.closest('[data-facet]');
          const open = facet.classList.contains('is-open');
          if (DESKTOP()) {
            this.closeAllFacets();
          }
          facet.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    }
    closeAllFacets() {
      qsa('[data-facet].is-open', this.form).forEach((f) => {
        f.classList.remove('is-open');
        const b = qs('[data-facet-toggle]', f);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    bindOutside() {
      document.addEventListener('click', (e) => {
        if (!DESKTOP()) return;
        if (!e.target.closest('[data-facet]')) this.closeAllFacets();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllFacets();
          if (this.drawer && this.drawer.getAttribute('aria-hidden') === 'false') this.closeDrawer();
        }
      });
    }

    /* ---- drawer mobile ---- */
    bindDrawer() {
      const openBtn = qs('[data-bzf-open]', this.toolbar);
      const closeBtn = this.drawer ? qs('[data-bzf-close]', this.drawer) : null;
      if (openBtn) openBtn.addEventListener('click', () => this.openDrawer());
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeDrawer());
      if (this.overlay) this.overlay.addEventListener('click', () => this.closeDrawer());
    }
    openDrawer() {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('bzf-drawer-open');
      const ob = qs('[data-bzf-open]', this.toolbar);
      if (ob) ob.setAttribute('aria-expanded', 'true');
    }
    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.classList.remove('bzf-drawer-open');
      const ob = qs('[data-bzf-open]', this.toolbar);
      if (ob) ob.setAttribute('aria-expanded', 'false');
    }

    /* ---- inputs del form -> filtro instant ---- */
    bindForm() {
      this.form.addEventListener('change', (e) => {
        const input = e.target;
        if (input.matches('input[type="checkbox"]')) this.syncLabel(input);
        this.scheduleApply();
      });
      // prezzo: campi numerici reagiscono mentre si digita
      qsa('input[type="number"]', this.form).forEach((n) => {
        n.addEventListener('input', () => this.scheduleApply());
      });
    }
    syncLabel(input) {
      const sw = input.closest('.bzf-swatch');
      if (sw) sw.classList.toggle('is-active', input.checked);
      const pill = input.closest('.bzf-pill');
      if (pill) pill.classList.toggle('is-active', input.checked);
    }
    syncActiveStates() {
      qsa('.bzf-swatch input:checked, .bzf-pill input:checked', this.form).forEach((i) => this.syncLabel(i));
    }

    /* ---- fasce prezzo rapide ---- */
    bindPriceChips() {
      qsa('[data-price-range-chip]', this.form).forEach((chip) => {
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          const minName = chip.dataset.minName;
          const maxName = chip.dataset.maxName;
          const minIn = minName ? this.form.querySelector(`[name="${CSS.escape(minName)}"]`) : null;
          const maxIn = maxName ? this.form.querySelector(`[name="${CSS.escape(maxName)}"]`) : null;
          const wasActive = chip.classList.contains('is-active');
          // reset siblings
          const group = chip.closest('.bzf-price__quick');
          if (group) qsa('[data-price-range-chip]', group).forEach((c) => c.classList.remove('is-active'));
          if (wasActive) {
            if (minIn) minIn.value = '';
            if (maxIn) maxIn.value = '';
          } else {
            chip.classList.add('is-active');
            if (minIn) minIn.value = chip.dataset.min || '';
            if (maxIn) maxIn.value = chip.dataset.max || '';
          }
          this.scheduleApply();
        });
      });
    }

    bindSort() {
      if (this.sortSelect) this.sortSelect.addEventListener('change', () => this.applyFilters());
    }

    bindClear() {
      qsa('[data-bzf-clear]', this.toolbar).forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.applyFilters(window.location.pathname, true);
        })
      );
    }
    bindApply() {
      // su mobile il CTA "Mostra N" applica (gia' applicato instant) e chiude
      qsa('[data-bzf-apply]', this.toolbar).forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeDrawer();
        })
      );
    }

    bindActiveRemoval() {
      if (!this.activeWrap) return;
      this.activeWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-remove-filter]');
        if (!btn) return;
        e.preventDefault();
        const url = btn.dataset.removeFilter;
        if (url) this.applyFilters(url, true);
      });
    }

    /* ---- core: filtro AJAX ---- */
    scheduleApply() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.applyFilters(), 350);
    }

    buildUrl() {
      const fd = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) {
        if (v !== '' && v != null) params.append(k, v);
      }
      if (this.sortSelect && this.sortSelect.value) params.set('sort_by', this.sortSelect.value);
      const qsStr = params.toString();
      return window.location.pathname + (qsStr ? '?' + qsStr : '');
    }

    async applyFilters(forcedUrl, reset) {
      const url = forcedUrl || this.buildUrl();
      this.grid.classList.add('loading');
      try {
        let html = this.cache.get(url);
        if (!html) {
          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          html = await res.text();
          this.cache.set(url, html);
        }
        this.render(html, reset);
        window.history.replaceState({}, '', url);
        if (window.gtag) window.gtag('event', 'filter_products', { event_category: 'Filters', value: url });
      } catch (err) {
        console.error('[bzf-filters] errore:', err);
      } finally {
        this.grid.classList.remove('loading');
      }
    }

    render(html, reset) {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // griglia prodotti
      const newGrid = doc.querySelector('[data-products-grid]');
      if (newGrid) {
        this.grid.style.opacity = '0';
        setTimeout(() => {
          this.grid.innerHTML = newGrid.innerHTML;
          this.grid.style.opacity = '1';
          this.reinit();
        }, 150);
      }

      // chip filtri attivi
      const newActive = doc.querySelector('[data-active-filters]');
      if (newActive && this.activeWrap) this.activeWrap.innerHTML = newActive.innerHTML;

      // paginazione (load more) coerente coi risultati filtrati
      this.syncPagination(doc);

      // conteggio risultati (collection.products_count gia' filtrato)
      const newCount = doc.querySelector('[data-results-count]');
      if (newCount) {
        const n = newCount.textContent.trim();
        qsa('[data-results-count]').forEach((el) => (el.textContent = n));
      }

      // conteggi/disabled delle opzioni facet
      this.syncFacetCounts(doc);

      // se reset: riallinea il form a quello renderizzato
      if (reset) this.resetFormFrom(doc);

      this.updateActiveCount();
    }

    syncFacetCounts(doc) {
      // allinea count e stato disabled opzione per opzione (per name+value)
      qsa('input[name]', doc.querySelector('[data-filters-form]') || doc).forEach((newIn) => {
        const sel = `input[name="${CSS.escape(newIn.name)}"][value="${CSS.escape(newIn.value)}"]`;
        const cur = this.form.querySelector(sel);
        if (!cur) return;
        cur.disabled = newIn.disabled;
        const curLabel = cur.closest('.bzf-swatch, .bzf-pill, .bzf-check');
        if (curLabel) curLabel.classList.toggle('is-disabled', newIn.disabled);
      });
      // count testuali (lista generica)
      const newCounts = qsa('.bzf-check__count', doc);
      const curCounts = qsa('.bzf-check__count', this.form);
      newCounts.forEach((nc, i) => { if (curCounts[i]) curCounts[i].textContent = nc.textContent; });
    }

    resetFormFrom() {
      qsa('input', this.form).forEach((i) => {
        if (i.type === 'checkbox') i.checked = false;
        else if (i.type === 'number') i.value = '';
      });
      qsa('.is-active', this.form).forEach((el) => el.classList.remove('is-active'));
    }

    updateActiveCount() {
      const n = qsa('input:checked', this.form).length + qsa('input[type="number"]', this.form).filter((i) => i.value !== '').length;
      qsa('[data-bzf-count-active]').forEach((el) => {
        el.textContent = n;
        el.hidden = n === 0;
      });
      qsa('[data-facet]', this.form).forEach((facet) => {
        const active = qsa('input:checked', facet).length + qsa('input[type="number"]', facet).filter((i) => i.value !== '').length;
        facet.classList.toggle('is-active', active > 0);
        let badge = qs('[data-facet-badge]', facet);
        const pill = qs('[data-facet-toggle]', facet);
        if (active > 0) {
          if (!badge && pill) {
            badge = document.createElement('span');
            badge.className = 'bzf-facet__badge';
            badge.setAttribute('data-facet-badge', '');
            pill.querySelector('.bzf-facet__chev')?.before(badge);
          }
          if (badge) badge.textContent = active;
        } else if (badge) {
          badge.remove();
        }
      });
    }

    reinit() {
      if (window.BeezfySwatchSystem) window.BeezfySwatchSystem.init();
      if (window.BeezfyATCSystem) window.BeezfyATCSystem.init();
      window.dispatchEvent(new CustomEvent('beezfy:filters:updated'));
      window.dispatchEvent(new CustomEvent('bzf:products:rendered'));
    }
  }

  function boot() {
    const root = qs('[data-bzf-toolbar]');
    if (root) new BzfFilters2027(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
